import { Helmet } from 'react-helmet-async';
import { useStoreInfo } from '@/lib/store';

export function TermsOfServicePage() {
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Terms of Service${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Our terms of service and conditions of use" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>

            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section className="space-y-4">
                <p>
                  These Terms of Service ("Terms") govern your access to and use of {storeInfo?.site_name || 'our'} website and services.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Acceptance of Terms</h2>
                <p>By accessing or using our website, you agree to be bound by these Terms and our Privacy Policy.</p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Products and Services</h2>
                <p>
                  We strive to display our products and their availability as accurately as possible. However, we do not guarantee that product information or availability is always accurate or up-to-date.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Ordering and Payment</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>All orders are subject to acceptance and availability.</li>
                  <li>Prices are subject to change without notice.</li>
                  <li>Payment must be made in full at the time of ordering.</li>
                  <li>We accept various payment methods as displayed during checkout.</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Separate Payment Policy</h2>
                <p>For orders requiring separate payments (goods and shipping):</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Goods payment and shipping payment must be made separately to designated accounts.</li>
                  <li>Do not combine payments into a single transaction.</li>
                  <li>Combined payments will NOT be refunded.</li>
                  <li>Orders with combined payments will NOT be shipped.</li>
                  <li>Always follow the payment instructions provided during checkout.</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Stockpile Policy</h2>
                <p>For stockpile orders:</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Stockpile items are held at our facility for customer pickup or consolidated shipping.</li>
                  <li>Items can be stored for a specified period as communicated during purchase.</li>
                  <li>Additional fees may apply for extended storage.</li>
                  <li>Contact us to arrange pickup or shipping of stockpiled items.</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Delivery and Waybill Processing</h2>
                <p>Once you pay for shipping:</p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Your waybill will be processed automatically with the next available batch.</li>
                  <li>You will receive tracking information via email once your waybill is generated.</li>
                  <li>Delivery times vary by location (1-7 days depending on your area).</li>
                  <li>We are not responsible for delays beyond our control.</li>
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Intellectual Property</h2>
                <p>All content on our website is our property and is protected by copyright and other intellectual property laws.</p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Limitation of Liability</h2>
                <p>We are not liable for any indirect, incidental, special, or consequential damages arising from your use of our services.</p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Changes to Terms</h2>
                <p>We reserve the right to modify these Terms at any time. Your continued use of our website following any changes constitutes acceptance of those changes.</p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-semibold text-gray-900">Contact Us</h2>
                <p>If you have any questions about these Terms, please contact us at {storeInfo?.contact_email || 'our contact email'}.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}